export default "__VITE_ASSET__C_i_AKsf__"